import axios from 'axios';
import { datajs, datajsAll, debounce } from '../shared/utils';

const serviceSearch = () => {
	const input = datajs('service-search-input');
	const letters = datajsAll('service-search-letter');
	const showAllServicesBtn = datajs('show-all-services');
	const expandAllServicesBtn = datajs('expand-all-services');

	if (!input) {
		return;
	}

	const serviceSearch = function (e) {
		e.preventDefault();

		const adminUrl = window.AppGlobals.adminUrl;
		const gridContainer = datajs('service-search-result-container');
		const params = new URLSearchParams();
		const eventTarget = e.target;
		let isLetterSearch = false;
		let searchInput = input.value;
		let showAllServices = false;

		if (!gridContainer) {
			console.error('A valid container to populate with the search result is not defined');
			return;
		}

		// Handle letter clicks
		if (e.type === 'click') {
			// Letter click
			if (eventTarget.dataset.js === 'service-search-letter') {
				if (eventTarget.classList.contains('is-active')) {
					eventTarget.classList.remove('is-active');
				} else {
					input.value = '';
					isLetterSearch = true;
					searchInput = eventTarget.innerHTML;
					letters.forEach((letter) => letter.classList.remove('is-active'));
					eventTarget.classList.add('is-active');
				}
			}

			// If "Show all services button is pressed"
			if (eventTarget.dataset.js === 'show-all-services') {
				showAllServices = true;
				searchInput = '';
			}
		}

		// Remove any active letter when the input field is used
		if (e.type === 'input') {
			letters.forEach((letter) => letter.classList.remove('is-active'));
		}

		params.append('action', 'service_search');
		params.append('s', searchInput);
		params.append('is_letter_search', isLetterSearch);
		params.append('show_all_services', showAllServices);

		gridContainer.classList.add('is-searching');

		axios
			.post(`${adminUrl}admin-ajax.php`, params)
			.then((res) => {
				// Apply result
				if (res.data.success) {
					gridContainer.innerHTML = res.data.data;

					if (eventTarget.dataset.js === 'show-all-services' || searchInput !== '') {
						showAllServicesBtn?.classList.add('d-none');
					} else {
						showAllServicesBtn?.classList.remove('d-none');
					}
				}
			})
			.catch((error) => {
				console.error(error);
			})
			.finally(() => {
				gridContainer.classList.remove('is-searching');
				gridContainer.classList.remove('is-prestine');
			});
	};

	const debouncedServiceSearch = debounce(serviceSearch, 300);

	input.addEventListener('input', debouncedServiceSearch);
	letters.forEach((letter) => {
		letter.addEventListener('click', serviceSearch);
	});

	if (showAllServicesBtn) {
		showAllServicesBtn.addEventListener('click', serviceSearch);
	}

	if (expandAllServicesBtn) {
		expandAllServicesBtn.addEventListener('click', (e) => {
			e.preventDefault();
			const gridContainer = datajs('service-search-result-container');

			if (gridContainer) {
				gridContainer.classList.add('is-expanded');
				gridContainer.classList.remove('is-prestine');
			}
		});
	}
};

export default serviceSearch;
